module.exports = __webpack_public_path__ + "static/media/dutchie_logo.f53d83a0.png";